__turbopack_context__.v({
  "authorAvatar": "GuideCard-module-scss-module__HwmHOq__authorAvatar",
  "authorImage": "GuideCard-module-scss-module__HwmHOq__authorImage",
  "authorName": "GuideCard-module-scss-module__HwmHOq__authorName",
  "backgroundImage": "GuideCard-module-scss-module__HwmHOq__backgroundImage",
  "cardContent": "GuideCard-module-scss-module__HwmHOq__cardContent",
  "numEvents": "GuideCard-module-scss-module__HwmHOq__numEvents",
  "root": "GuideCard-module-scss-module__HwmHOq__root",
});
